import React from 'react';
import MetricTrackingPage from './MetricTrackingPage';

export default function GestionBMI() {
  return <MetricTrackingPage type="bmi" title="Índice de masa corporal" description="Mantén un historial claro de tu IMC y revisa los cambios a lo largo del tiempo." field="bmi" unit="IMC" inputLabel="Índice de masa corporal" />;
}
